
import { defineComponent, PropType } from 'vue';
import { CancelReason } from '../cancelFlow';

export default defineComponent({
    name: 'CancelFeedback',
    props: {
        reasons: { type: Array as PropType<CancelReason[]>, default: () => [] },
        selectedReasons: { type: Array as PropType<string[]>, default: () => [] },
        otherText: { type: String, default: '' },
        // True while the Stripe cancel is in flight; buttons lock.
        finalizing: { type: Boolean, default: false },
        // Set by the container when the cancel failed; the user stays here.
        errorMessage: { type: String, default: '' },
    },
    emits: ['next', 'stay', 'toggle-reason', 'update:other-text'],
    computed: {
        // FLOCK-6715: "Other" needs its free-text before the flow continues.
        // Only flagged once the screen has actually been blocked, so the field
        // is not marked invalid the moment it appears.
        otherTextMissing(): boolean {
            return !!this.errorMessage
                && this.selectedReasons.indexOf('other') >= 0
                && !this.otherText.trim();
        },
    },
});
